"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _notistack = require("notistack");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SnackbarCloseButton = function SnackbarCloseButton(_ref) {
  var snackbarKey = _ref.snackbarKey;

  var _useSnackbar = (0, _notistack.useSnackbar)(),
      closeSnackbar = _useSnackbar.closeSnackbar;

  return _react.default.createElement(_IconButton.default, {
    key: "close",
    "aria-label": "close",
    color: "inherit",
    onClick: function onClick() {
      return closeSnackbar(snackbarKey);
    }
  }, _react.default.createElement(_Close.default, null));
};

var _default = SnackbarCloseButton;
exports.default = _default;